import { 
  collection, addDoc, updateDoc, deleteDoc, doc, getDocs, getDoc, query, where, orderBy, Timestamp 
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'articulos';


export const crearArticulo = async (articuloData) => {
  try {
    const dataWithTimestamp = {
      ...articuloData,
      fechaPublicacion: Timestamp.now(),
      fechaActualizacion: Timestamp.now(),
      activo: true,
      vistas: 0
    };
    const docRef = await addDoc(collection(db, COLLECTION_NAME), dataWithTimestamp);
    return { id: docRef.id, ...dataWithTimestamp };
  } catch (error) {
    console.error("Error al crear artículo:", error);
    throw error;
  }
};


export const obtenerArticulos = async () => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      where("activo", "==", true),
      orderBy("fechaPublicacion", "desc")
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      fechaPublicacion: doc.data().fechaPublicacion?.toDate()
    }));
  } catch (error) {
    console.error("Error al obtener artículos:", error);
    throw error;
  }
};

export const obtenerArticuloPorId = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return {
        id: docSnap.id,
        ...docSnap.data(),
        fechaPublicacion: docSnap.data().fechaPublicacion?.toDate()
      };
    }
    return null;
  } catch (error) {
    console.error("Error al obtener artículo:", error);
    throw error;
  }
};


export const incrementarVistas = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const vistasActuales = docSnap.data().vistas || 0;
      await updateDoc(docRef, { vistas: vistasActuales + 1 });
    }
  } catch (error) {
    console.error("Error al incrementar vistas:", error);
  }
};


export const actualizarArticulo = async (id, datosActualizados) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, {
      ...datosActualizados,
      fechaActualizacion: Timestamp.now()
    });
    return true;
  } catch (error) {
    console.error("Error al actualizar artículo:", error);
    throw error;
  }
};


export const eliminarArticulo = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, { activo: false });
    return true;
  } catch (error) {
    console.error("Error al eliminar artículo:", error);
    throw error;
  }
};